import { render, staticRenderFns } from "./bloodPressureCollaborative.vue?vue&type=template&id=35a21168"
import script from "./bloodPressureCollaborative.vue?vue&type=script&lang=js"
export * from "./bloodPressureCollaborative.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports